import Vue from 'vue'
import VueRouter from 'vue-router'
import technologyUpdateFlowGuard from '@/router/middlewares/technologyUpdateFlowGuard';
import msisdnGuard from '@/router/middlewares/msisdnGuard';
import AuthenticityCheck from '../views/AuthenticityCheck.vue'
import InformationCheck from '../views/InformationCheck.vue'
import Protocol from '../views/Protocol.vue'
import NewChipInformation from '../views/NewChipInformation.vue'
import Welcome from '../views/Welcome.vue'
import WelcomeExOi from '../views/WelcomeExOi.vue'
import Documents from '../views/Documents.vue'
import Code from '../views/Code.vue'
import NewChip from '../views/NewChip.vue'
import BarcodeInstructions from '../views/BarcodeInstructions.vue';
import Activate from "../views/Activate"
import ActivateEsim from "../views/ActivateEsim.vue"
import NotFound from "../views/NotFound"
import Reason from "../views/Reason"
import CorporateClientBlock from "../views/CorporateClientBlock";
import DefaultError from "../views/DefaultError";
import CallTim from '../views/CallTIM';
import WifiError from '../views/WifiError';
import InstallationGuide from '../views/InstallationGuide';
import Loading from '../views/Loading';
import NewChipeSim from "../views/NewChipeSim";
import ChangeChip from "../views/ChangeChip";
import DeviceSelection from "../views/DeviceSelection.vue";
import EmailValidation from "../views/EmailValidation.vue";
import TimeOutEmail from "../views/TimeOutEmail.vue";
import ChipExchangeClosed from "../views/ChipExchangeClosed.vue";
import DifficultCompleteExchange from "../views/DifficultCompleteExchange.vue";
import FinishingScreenPage from "../views/FinishingScreenPage.vue";
import LoadingProcess from "../views/LoadingProcess.vue";
import InstallationEsim from "../views/InstallationEsim.vue";

import middlewares from "../router/middlewares/index";
import store from '../store';

Vue.use(VueRouter)
  const routes = [
  {
    path: '/',
    name: 'welcome',
    component: Welcome
  },
  {
    path: '/welcome-exoi',
    name: 'welcome-exoi',
    component: WelcomeExOi
  },  
  {
    path: '/motivos',
    name: 'reasons',
    component: Reason,
    beforeEnter: msisdnGuard
  },
  {
    path: '/eSim',
    name: 'eSimChip',
    component: NewChipeSim,
    beforeEnter: msisdnGuard
  },
  {
    path: '/ChipFisico',
    name: 'changeChip',
    component: ChangeChip,
    beforeEnter: msisdnGuard
  },
  {
    path: '/timeOutEmail',
    name: 'timeOutEmail',
    component: TimeOutEmail
  },
  {
    path: '/chipExchangeClosed',
    name: 'chipExchangeClosed',
    component: ChipExchangeClosed
  },
  {
    path: '/difficultCompleteExchange',
    name: 'difficultCompleteExchange',
    component: DifficultCompleteExchange
  },
  {
    path: '/finishingScreen',
    name: 'finishingScreen',
    component: FinishingScreenPage
  },
  {
    path: '/loadingProcess',
    name: 'loadingProcess',
    component: LoadingProcess
  },
  {
    path: '/device-selection',
    name: 'device-selection',
    component: DeviceSelection,
    beforeEnter: msisdnGuard
  },
  {
    path: '/documentos',
    name: 'documents',
    component: Documents,
    beforeEnter: technologyUpdateFlowGuard
  },
  {
    path: '/email-validation',
    name: 'email-validation',
    component: EmailValidation,
    beforeEnter: technologyUpdateFlowGuard
  },
  {
    path: '/codigo',
    name: 'code',
    component: Code,
    beforeEnter: msisdnGuard
  },
  {
    path: '/chip',
    name: 'chip',
    component: NewChip,
    beforeEnter: msisdnGuard
  },
  {
    path: '/instrucoes-barcode',
    name: 'instrucoes-barcode',
    component: BarcodeInstructions,
    beforeEnter: msisdnGuard
  },
  {
    path: '/ativado',
    name: 'activate',
    component: Activate,
    beforeEnter: msisdnGuard
  },
  {
    path: '/ativado-esim',
    name: 'activado-esim',
    component: ActivateEsim,
    beforeEnter: msisdnGuard
  },
  {
    path: '/install_esim',
    name: 'install_esim',
    component: InstallationEsim,
    beforeEnter: msisdnGuard
  },
  {
    path: '/acesso-negado',
    name: 'notfound',
    component: NotFound
  },
  {
    path: '/verificacao-de-informacoes',
    name: 'information-check',
    component: InformationCheck,
    beforeEnter: msisdnGuard
  },
  {
    path: '/protocolo',
    name: 'protocol',
    component: Protocol,
    beforeEnter: msisdnGuard
  },
  {
    path: '/novo-chip',
    name: 'new-chip-information',
    component: NewChipInformation,
    beforeEnter: msisdnGuard
  },
  {
    path: '/autencidade/:step',
    name: 'authenticity-check',
    component: AuthenticityCheck,
    beforeEnter: msisdnGuard
  },
  {
    path: '/corporate-client-block',
    name: 'corporate-client-block',
    component: CorporateClientBlock
  },
  {
    path: '/call-center',
    name: 'call-center',
    component: CallTim,
    beforeEnter: msisdnGuard
  },
  {
    path: '/error',
    name: 'default-error',
    component: DefaultError,
    beforeEnter: msisdnGuard,
    props: true
  },
  {
    path: '/wifierror',
    name: 'wifi-error',
    component: WifiError,
    beforeEnter: msisdnGuard,
  },
  {
    path: '/InstallationGuide',
    name: 'installation-guide',
    component: InstallationGuide,
    beforeEnter: msisdnGuard,
  },
  {
    path: '/loading-page',
    name: 'loading-page',
    component: Loading,
    beforeEnter: msisdnGuard,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(middlewares)

export async function goToLastRoute() {
    await store.dispatch('popRoute');
    
    const routeStack = store.getters.getRouteStack;
    const lastRoute = routeStack.pop();
    
    router.push(lastRoute);
}

export async function goToRoute(routePath) {
    let routeStack = store.getters.getRouteStack;
    const routeIndex = routeStack.findIndex((route) => route == routePath);

    routeStack = routeStack.slice(0, routeIndex + 1);
    store.commit('rewriteRoute', routeStack);

    router.push(routePath);
}

export default router;
